/* eslint-disable react/jsx-handler-names */
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import NoSSR from 'react-no-ssr';

import Button from '../../Button';

import HeaderLink from '../HeaderLink';
import HeaderItem from '../HeaderItem';
import HeaderItems from '../HeaderItems';

import themeShape, { DARK_THEME } from '../shapes/theme.shape';
import LoginIconButton from '../../LoginButtonComponent/LoginIconButton';
import HeaderSupportCenterRedesign from '../HeaderSupportCenterRedesign';
import LanguageSwitcher from '../LanguageSwitcher';

const HeaderNavSimplified = ({ color = DARK_THEME }) => {
  return (
    <HeaderItems>
      <HeaderItem>
        <Button
          color="white"
          className="ga-home-publish-your-property-top header-button"
          href={getPagePath('externals.landlord-landing')}
          size="small"
        >
          {trans('landingpage.button.landlord')}
        </Button>
      </HeaderItem>
      <HeaderItem>
        <Button
          color="white"
          className="ga-home-publish-your-property-top header-button"
          href={getPagePath('how-it-works')}
          size="small"
        >
          {trans('how_it_works.title')}
        </Button>
      </HeaderItem>
      <HeaderItem>
        <HeaderSupportCenterRedesign />
      </HeaderItem>
      <NoSSR>
        <HeaderItem>
          <LoginIconButton />
        </HeaderItem>
      </NoSSR>
      <HeaderItem>
        <HeaderLink color={color}>
          <LanguageSwitcher
            theme={color}
            abbreviated
            id="header-language-switcher-simplified"
          />
        </HeaderLink>
      </HeaderItem>
    </HeaderItems>
  );
};

HeaderNavSimplified.propTypes = {
  color: themeShape
};

export default HeaderNavSimplified;
